// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.76.1/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul.articles>li:before{content:none}.prose h1{line-height:3rem}.prose ul{list-style:none}.prose li{font-family:\"\"}.prose ul.articles{list-style:none;margin-left:0}.prose ul.articles>li{padding-left:0}.prose ul.articles>li figure.featured-image{margin-top:0}.prose ul.articles>li.article{margin-bottom:2rem}.prose ul.articles>li.article figure.featured-image>picture>img{margin-top:0;margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
